import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { HttpService, LanguageService, MapService, StateService } from '../../core/services';
import { DetourComponent, LoadingComponent, SearchInputComponent } from '../../shared/components';
import { TranslationPipe } from '../../shared/pipes';
import { ConnectionComponent } from './connection/connection.component';
import { ConnectionsState } from './connections-state';

@Component({
  selector: 'app-connections',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, SearchInputComponent, ConnectionComponent, DetourComponent, TranslationPipe, LoadingComponent],
  templateUrl: './connections.component.html'
})
export class ConnectionsComponent implements OnInit {
  private readonly searchSubject = new Subject<string>();
  term: string = "";
  state: ConnectionsState;
  placeholder: string = 'Název spoje...';
  loading = false;

  constructor(
    private readonly stateService: StateService,
    private readonly httpService: HttpService,
    private readonly mapService: MapService,
    private readonly languageService: LanguageService
  ) {
    this.state = this.stateService.read<ConnectionsState>('ConnectionsState') ?? new ConnectionsState();
  }

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchValue) => {
      this.searchTextChange(searchValue);
    });

    this.placeholder = this.languageService.translate('Název spoje...');
    this.onSearch(this.state.searchText); // abychom nekoukali na staré spoje
  }

  startHover(id: string) {
    this.mapService.highlightConnection(id);
  }

  endHover(id: string) {
    this.mapService.highlightConnectionEnd(id);
  }

  onSearch(term: string) {
    this.term = term;
    if (term) {
      this.searchSubject.next(term);
    }
    else
      this.state.searchedConnections = [];
  }

  private searchTextChange(input: string) {
    this.loading = true;
    this.state.searchText = input;
    this.state.searchedConnections = [];
    this.httpService.findConns(this.state.searchText).subscribe({
      next: result => {
        this.state.searchedConnections = result;
        this.stateService.store('ConnectionsState', this.state);
        this.loading = false;
      }
    });
  }
}
